var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mounted
    ? _c(
        "FormGroup",
        {
          staticClass: "postal-code-edit",
          attrs: { "add-invalid-class": false, "feedback-beneath": "" }
        },
        [
          _c(
            "div",
            { staticClass: "postal-code-edit--container" },
            [
              _vm.withCountrySelection
                ? _c(
                    "div",
                    [
                      _c("CountrySelect", {
                        attrs: {
                          meta: _vm.meta,
                          "empty-option": "--- Land wählen ---"
                        },
                        on: { input: _vm.countryChanged },
                        model: {
                          value: _vm.country,
                          callback: function($$v) {
                            _vm.country = $$v
                          },
                          expression: "country"
                        }
                      })
                    ],
                    1
                  )
                : _c("div", [_vm._v("Österreich:")]),
              _vm._v(" "),
              _c(
                "FormGroup",
                { staticClass: "ml-0 ml-md-2 mb-0 flex-grow-1 mt-2 mt-md-0" },
                [
                  (_vm.withCountrySelection && !_vm.country) ||
                  _vm.unknownCountry
                    ? _c("b-input", {
                        staticClass: "postal-code",
                        attrs: {
                          disabled: !_vm.unknownCountry,
                          placeholder: "Postleitzahl / Ort eingeben"
                        },
                        on: { input: _vm.emitChangeEvent },
                        model: {
                          value: _vm.postalCodeFree,
                          callback: function($$v) {
                            _vm.postalCodeFree = $$v
                          },
                          expression: "postalCodeFree"
                        }
                      })
                    : _c("Dropdown", {
                        attrs: {
                          "custom-options": _vm.options,
                          multiple: _vm.multiple,
                          coloring: _vm.coloring,
                          "search-type": "postal-code-city",
                          placeholder: "Postleitzahl eingeben"
                        },
                        on: { input: _vm.emitChangeEvent },
                        model: {
                          value: _vm.postalCodes,
                          callback: function($$v) {
                            _vm.postalCodes = $$v
                          },
                          expression: "postalCodes"
                        }
                      })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }